var zoomFunction = function() {
	var delayTime = 1500;
	var scale = 1;
	var zoomMin = 1;
	var zoomMax = 4;
	var imageUrl = "";
	var bigImageWidth = 0;
	var bigImageHeight = 0;
	var thumbWidth = 0;
	var thumbHeight = 0;
	var maxThumbHeight = 127;
	var bigImageConteiner = null;
	var bigImage = null;
	var paintingDiv = null;
	var zoomExtraData = null;
	var zoomExtra = null;
	var thumbImageBorder = null;
	var paintingThumbConteiner = null;
	var hideThumb = null;
	var delayTime = 1500;
	var that = this;
	var lastTimeMouseMoved = "";
	$(document).on('mousemove mouseclick', function(event) {
		event.preventDefault();
		//clearTimeout(hideThumb);
		if (zoomExtra !== null) {
			if (!zoomExtra.hasClass('opacity1')) {
				showThumbF();
			}

			lastTimeMouseMoved = new Date().getTime();
			hideThumb = setTimeout(function() {
				var currentTime = new Date().getTime();
				if (currentTime - lastTimeMouseMoved > delayTime) {
					hideThumbF();
				}
			}, delayTime);
		}
	});

	$(window).resize(function() {
		init(that.imageUrl);
	});

	function getMeta(url) {
		var r = $.Deferred();

		$('<img/>').attr('src', url).load(function() {
			var s = {
				w: this.width,
				h: this.height
			};
			r.resolve(s)
		});
		return r;
	}

	function calculateZoom() {

		var differenceY = parseFloat(bigImageConteiner.offset().top - bigImage.offset().top);
		var differenceX = parseFloat(bigImageConteiner.offset().left - bigImage.offset().left);

		var imageWidth = parseFloat(bigImage.width() * scale);
		var imageHeight = parseFloat(bigImage.height() * scale);
		var imageConteinerWidth = parseFloat(bigImageConteiner.width());
		var imageConteinerHeight = parseFloat(bigImageConteiner.height());

		var thumbConteinerWidth = parseFloat(paintingThumbConteiner.width());
		var thumbConteinerHeight = parseFloat(paintingThumbConteiner.height());
		var newWidth = parseFloat(imageConteinerWidth * thumbConteinerWidth / imageWidth); //parseFloat(imageConteinerWidth*thumbConteinerWidth/imageWidth);
		var newHeight = parseFloat(imageConteinerHeight * thumbConteinerHeight / imageHeight);

		var newLeft = parseFloat(thumbConteinerWidth * differenceX / imageWidth);
		var newTop = parseFloat(thumbConteinerHeight * differenceY / imageHeight);

		if (parseFloat(paintingThumbConteiner.width()) < newWidth) {
			newWidth = parseFloat(paintingThumbConteiner.width());
			newLeft = 0;
		}
		if (parseFloat(paintingDiv.width()) >= parseFloat(bigImage.width()) * scale) {
			newWidth = parseFloat(paintingThumbConteiner.width());
			newLeft = 0;
		}

		thumbImageBorder.css({
			width: newWidth + 'px',
			height: newHeight + 'px',
			top: newTop + 'px',
			left: newLeft + 'px'
		});

		var ok = true;
		if (newTop < 0) {
			newTop = 0;
			ok = false;
		} else if (thumbImageBorder.height() + newTop > paintingThumbConteiner.height()) {
			newTop = paintingThumbConteiner.height() - thumbImageBorder.height();
			ok = false;
		}
		if (newLeft < 0) {
			newLeft = 0;
			ok = false;
		} else if (thumbImageBorder.width() + newLeft > paintingThumbConteiner.width()) {
			newLeft = paintingThumbConteiner.width() - thumbImageBorder.width();
			ok = false;
		}

		if (!ok) {
			thumbImageBorder.css({
				width: newWidth + 'px',
				height: newHeight + 'px',
				top: newTop + 'px',
				left: newLeft + 'px'
			});
			moveBigImage();
		}

		if (parseFloat(scale) == 1.0) {
			bigImage.css({
				top: 0,
				left: 0,
				width: '',
				height: ''
			});
			thumbImageBorder.css({
				top: 0,
				left: 0
			});

			$(".slick-active .thumbImageCol").animate({
				opacity: 1
			}, delayTime);
			$(".slick-active .detailsCol").removeClass("opacity0");
		} else {
			$(".slick-active .detailsCol").addClass("opacity0");
			$(".slick-active .thumbImageCol").animate({
				opacity: 0
			}, delayTime);
		}
	}

	function strip(html) {
		var tmp = document.createElement("DIV");
		tmp.innerHTML = html;
		return tmp.textContent || tmp.innerText || "";
	}

	function moveBigImage() {

		var imageWidth = parseFloat(bigImage.width() * scale);
		var imageHeight = parseFloat(bigImage.height() * scale);
		var imageConteinerWidth = parseFloat(bigImageConteiner.width());
		var imageConteinerHeight = parseFloat(bigImageConteiner.height());

		var thumbConteinerWidth = parseFloat(paintingThumbConteiner.width());
		var thumbConteinerHeight = parseFloat(paintingThumbConteiner.height());
		var tw = thumbImageBorder.width();
		var th = thumbImageBorder.height();
		var thumbLeft = thumbImageBorder.css("left").replace("px", "");
		var thumbTop = thumbImageBorder.css("top").replace("px", "");

		var differenceX = thumbLeft * imageWidth / thumbConteinerWidth;
		var differenceY = thumbTop * imageHeight / thumbConteinerHeight;

		var newLeft = parseFloat(bigImageConteiner.offset().left - differenceX);
		var newTop = parseFloat(bigImageConteiner.offset().top - differenceY);

		bigImage.offset({
			top: newTop,
			left: newLeft
		});
	}

	function showThumbF() {
		clearTimeout(hideThumb);
		zoomExtra.css("opacity", "1");
		zoomExtra.addClass('opacity1');
	}

	function hideThumbF() {
		//canHideThumb=false;
		zoomExtra.css("opacity", "1");
		zoomExtra.removeClass('opacity1');
		zoomExtra.animate({
				opacity: 0
			},
			delayTime,
			function() {
				//canHideThumb=true;
				zoomExtra.removeClass('opacity1');
				clearTimeout(hideThumb);
			}
		);
	}

	function init(imageUrl) {
		bigImageConteiner = $('.works-wrap .slick-active .bigImageConteiner');
		bigImage = $('.works-wrap .slick-active .bigImage');
		paintingDiv = $(".works-wrap .slick-active .paintingDiv");
		thumbImageBorder = $(".works-wrap .slick-active .thumbImageBorder");
		paintingThumbConteiner = $('.slick-active .paintingThumbConteiner');
		zoomExtraData = $('.slick-active .zoom-extra-data');
		zoomExtra = $('.slick-active .zoom-extra');

		var startXThumb = 0,
			startYThumb = 0,
			xThumb = 0,
			yThumb = 0;
		if ($(window).width() > 768) {
			bigImage.css({
				left: '0',
				top: '0'
			});
			bigImage.draggable({
				//var startX = 0, startY = 0, x = 0, y = 0;
				start: function() {;
				},
				drag: function() {
					calculateZoom();
				}
			});
		} else {
			if (bigImage.data('ui-draggable')) {
				bigImage.draggable('disable');
			}
		}

		thumbImageBorder.draggable({
			start: function(event, ui) {
				var currentPos = ui.helper.position();
				startXThumb = parseInt(currentPos.left) - xThumb;
				startYThumb = parseInt(currentPos.top) - yThumb;
			},
			drag: function(event, ui) {
				var currentPos = ui.helper.position();
				var curLeft = parseInt(currentPos.left);
				var curTop = parseInt(currentPos.top);

				if (curLeft < 0) {
					curLeft = 0;
				}
				if (curTop < 0) {
					curTop = 0;
				}

				if (thumbImageBorder.width() + curLeft > paintingThumbConteiner.width()) {
					curLeft = paintingThumbConteiner.width() - thumbImageBorder.width();
				}

				if (thumbImageBorder.height() + curTop > paintingThumbConteiner.height()) {
					curTop = paintingThumbConteiner.height() - thumbImageBorder.height();
				}
				thumbImageBorder.css({
					left: curLeft + 'px',
					top: curTop + 'px'
				});


				moveBigImage();
			},
			stop: function(event, ui) {
				var currentPos = ui.helper.position();
				var curLeft = parseInt(currentPos.left);
				var curTop = parseInt(currentPos.top);

				if (curLeft < 0) {
					curLeft = 0;
				}
				if (curTop < 0) {
					curTop = 0;
				}
				if (thumbImageBorder.width() + curLeft > paintingThumbConteiner.width()) {
					curLeft = paintingThumbConteiner.width() - thumbImageBorder.width();
				}

				if (thumbImageBorder.height() + curTop > paintingThumbConteiner.height()) {
					curTop = paintingThumbConteiner.height() - thumbImageBorder.height();
				}

				thumbImageBorder.css({
					left: curLeft + 'px',
					top: curTop + 'px'
				});


				moveBigImage();
			}
		});
		$(".slick-active .slider").slider();

		getMeta(imageUrl).done(function(test) {
			bigImageWidth = test.w;
			bigImageHeight = test.h;
			thumbHeight = maxThumbHeight;
			thumbWidth = parseInt(bigImageWidth * thumbHeight / bigImageHeight);
			calculateZoom();

			thumbImageBorder.css({
				height: thumbHeight + 'px',
				width: thumbWidth + 'px',
				left: 0,
				top: 0
			});
			$(".slick-active .paintingThumbInner").css({
				height: thumbHeight + 'px',
				width: thumbWidth + 'px',
				left: 0,
				top: 0
			});

			bigImageConteiner.css({
				"width": "100%"
			});
			$(".slick-active .bigImageCol").css({
				"left": "0"
			});

			if (scale < 0) {
				scale = 1;
			}

			bigImage.css("transform", "scale(" + scale + ")");
			bigImage.css("-ms-transform", "scale(" + scale + ")");
			bigImage.css("-webkit-transform", "scale(" + scale + ")");


			bigImage.css({
				left: 0,
				top: 0
			});

			$(".slick-active .slider .ui-slider-handle").css("left", "0%");
			$(".slick-active .slider").trigger("slidechange");
		});
	}

	$(document).on("draggable mouseenter mousedown", ".slick-active .bigImage", function(event) {
		event.stopPropagation();
	});

	$(document).on("draggable mouseenter mousedown", ".slick-active .thumbImageBorder", function(event) {
		event.stopPropagation();
	});

	$(document).on("slidechange", ".slick-active .slider", function(event, ui) {
		var left = parseFloat($(".slick-active .slider .ui-slider-handle").css("left").replace("px", "")) / $(".slick-active .slider").width();
		scale = parseFloat((zoomMax - zoomMin) * left) + 1;
		scale = scale.toFixed(3);

		if (scale < 0) {
			scale = 1;
		}
		//console.log(scale)
		bigImage.css("transform", "scale(" + scale + ")");
		bigImage.css("-ms-transform", "scale(" + scale + ")");
		bigImage.css("-webkit-transform", "scale(" + scale + ")");
		calculateZoom();


		if (scale > 1.1) {
			zoomExtraData.css("display", "none");
		} else {
			zoomExtraData.css("display", "");
		}

		var maxWidth = parseInt(paintingDiv.outerWidth());
		var newWidth = parseInt($(".slick-active .bigImageCol").outerWidth() * scale);
		var bigWidth = newWidth;
		var bigLeft = 0;
		var bigImageColWidth = $(".slick-active .bigImageCol").outerWidth();

		if (newWidth > maxWidth) {
			bigWidth = maxWidth;
		}

		if (scale == 1) {
			bigWidth = $(".slick-active .bigImageCol").width();
		}

		if (bigWidth > bigImageColWidth) {
			bigLeft = (bigWidth - bigImageColWidth) / 2;
		}

		if (parseInt(bigWidth) === 0) {
			bigImageConteiner.css({
				"width": bigWidth + "px"
			});
		} else {
			bigImageConteiner.css({
				"width": "100%"
			});
		}
		$(".slick-active .bigImageCol").css({
			"left": "-" + bigLeft + "px"
		});
		//$('#measurements').html(' newWidth: '+newWidth+' bigImageCol: '+$(".bigImageCol").outerWidth()+' scale: '+scale)
	});

	return {
		init: init
	}
}();

var scrollTricks = function() {
	// Hide Header on on scroll down
	var didScroll;
	var lastScrollTop = 0;
	var delta = 1;
	var navbarHeight = $(".top-bar").outerHeight(); //$('header').outerHeight();

	$(window).scroll(function(event) {
		didScroll = true;
	});

	function init() {
		setInterval(function() {
			if (didScroll) {
				hasScrolled();
				didScroll = false;
			}
		}, 250);
	}

	function hasScrolled() {
		var st = $(window).scrollTop();
		navbarHeight = $(".top-bar").outerHeight();

		// Make sure they scroll more than delta
		if (Math.abs(lastScrollTop - st) <= delta)
			return;

		// If they scrolled down and are past the navbar, add class .nav-up.
		// This is necessary so you never see what is "behind" the navbar.
		if (st > lastScrollTop && st > navbarHeight) {
			// Scroll Down
			$('header').addClass('nav-up');
			$('#cssmenu ul.parent-level').addClass('menu-up');
			$('.menu-bar').addClass('mini');
			$('.logo').addClass('mini');
		} else {
			// Scroll Up
			if (st + $(window).height() < $(document).height()) {
				$('header').removeClass('nav-up');
				$('#cssmenu ul.parent-level').removeClass('menu-up');
				$('.logo').removeClass('mini');
			}
		}

		lastScrollTop = st;
	}
	return {
		init: init
	}
}();

$(document).ready(function(e) {
	var srollt = scrollTricks;
	srollt.init();

	if ($('.cat-slider').length) {

		var zoomF = zoomFunction;
		var catSlider = $('.cat-slider');

		catSlider.on('init', function() {
			if ($(".slick-active .bigImage img").length) {
				$(".cat-slider .slick-slide").removeClass("visibilityH");

				$('*[draggable!=true]', '.cat-slider').unbind('dragstart');

				let imageUrl = $(".slick-active .bigImage img").attr("src");

				zoomF.init(imageUrl);
			}
		});
		if ($(".bigImage img").length) {
			$(".cat-slider .slick-slide").addClass("visibilityH");
			catSlider.slick({
				lazyLoad: 'ondemand',
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				asNavFor: '.slider-nav',
				speed: 300,
				dots: false,
				draggable: false,
				swipe: false
			});
		} else {
			catSlider.slick({
				lazyLoad: 'ondemand',
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				asNavFor: '.slider-nav',
				speed: 300,
				dots: false
			});
		}
		$('.slider-nav').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			centerMode: false,
			focusOnSelect: true,
			dots: false,
			variableWidth: true,
			infinite: false,
			responsive: [{
				breakpoint: 550,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}]
		});

		$(document).on("click", ".slider-nav  .slick-slide", function(event) {
			var index = $(this).attr("data-slick-index");
			$('.cat-slider').slick('slickGoTo', index);
		});

		$(document).on('click', '.cat-slider .slick-arrow', function() {
			if ($(".bigImage img").length) {
				let imageUrl = $(".cat-slider .slick-active .bigImage img").attr("src");
				zoomF.init(imageUrl);
			}
		});

		$(document).on('click', '.slider-nav .slick-slide', function() {
			if ($(".bigImage img").length) {
				let imageUrl = $(".cat-slider .slick-active .bigImage img").attr("src");
				zoomF.init(imageUrl);
			}
		});

		var moveButtons = null;
		var closeThumbs = setTimeout(function() {
			if ($(".slider-thumbs").length > 0 && $("#catalogues").length > 0) {
				$(".slider-thumbs").removeClass('open');
				$("#catalogues").removeClass('open');
			}
		}, 5000);

		$(document).on('mouseover', ".slider-nav .slick-arrow", function(event) {
			var that = $(this);
			clearTimeout(closeThumbs);
			moveButtons = setInterval(
				function() {
					that.trigger('click');
				}, 200
			);
		});
		$(document).on('mouseout', ".slider-nav .slick-arrow", function(event) {
			clearInterval(moveButtons);
		});
	}

	if ($('.cat-slider-inner').length) {
		$('.cat-slider-inner').slick({
			lazyLoad: 'ondemand',
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			asNavFor: '.slider-nav-inner',
			speed: 300,
			dots: false
		});

		$('.slider-nav-inner').slick({
			slidesToShow: 8,
			slidesToScroll: 8,
			asNavFor: '.cat-slider-inner',
			infinite: false,
			centerMode: false,
			focusOnSelect: true,
			dots: true,
			customPaging: function(slider, i) {
				var thumb = $(slider.$slides[i]).data();
				return '<a>' + (i + 1) + '</a>';
			},
			responsive: [{
				breakpoint: 550,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}]
		});

		$('.slider-nav-inner').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			var currentSliderListArray = $(this).find(".slick-track");
			var currentSliderList = currentSliderListArray[0];
			var page = parseInt(nextSlide / 8);

			$(this).find(".slick-list").each(function(index, element) {
				var myHeight = (parseInt($(this).outerHeight(true)) - 1) * page;
				$(currentSliderList).css("top", "-" + myHeight + "px");
			});
		});
	}

	if ($('.virtual-tour__slider').length) {
		$('.virtual-tour__slider').slick({
			dots: true,
			customPaging: function(slider, i) {
				var thumb = $(slider.$slides[i]).data();
				return '<a>' + (i + 1) + '</a>';
			},
			infinite: false,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1
		});
	}

	if ($('.list-ex').length) {
		$('.list-ex').slick({
			dots: true,
			customPaging: function(slider, i) {
				var thumb = $(slider.$slides[i]).data();
				return '<a>' + (i + 1) + '</a>';
			},
			infinite: false,
			speed: 300,
			slidesToShow: 3,
			slidesToScroll: 3,
			responsive: [{
					breakpoint: 1024,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: true
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});
	}

	if ($('.list-vid').length) {
		$('.list-vid').slick({
			dots: true,
			customPaging: function(slider, i) {
				var thumb = $(slider.$slides[i]).data();
				return '<a>' + (i + 1) + '</a>';
			},
			infinite: false,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
			responsive: [{
					breakpoint: 1024,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						dots: true
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});
	}

	$("#catalogues").on('click', function(event) {
		event.preventDefault();
		$(".slider-thumbs").toggleClass('open');
		$("#catalogues").toggleClass('open');
	});

	$(".slider-thumbs-menu").on('mouseover', function(event) {
		if ($(".slider-thumbs").hasClass('open')) {

		} else {
			$(".slider-thumbs").toggleClass('open');
			$("#catalogues").toggleClass('open');
		}
	});

	$(".play-video").click(function() {
		event.preventDefault();
		var videosrc = $(this).data("video");
		var url = 'https://www.youtube.com/embed/' + videosrc;
		$(".video-iframe").attr('src', url);
	});

	$(".thumb-info").click(function() {
		var thumbTitle = $(this).data("title");
		var thumbDescription = $(this).data("description");
		var thumbArticleId = $(this).data("id");
		console.log(thumbArticleId);
		console.log(thumbDescription);
		$(".cat-extra #artworkTitle-" + thumbArticleId).html(thumbTitle);
		$(".cat-extra #artworkDesc-" + thumbArticleId).html(thumbDescription);
	});

	$(document).on('click', '.cat-slider-inner .slick-arrow', function() {
		var prevSlide = $('.cat-slider .slick-active .cat-slider-inner  .slick-active');
		var thumbArticleId = $(prevSlide).data("id");
		var thumbTitle = $(prevSlide).data("title");
		var thumbDescription = $(prevSlide).data("description");
		$(".cat-extra #artworkTitle-" + thumbArticleId).html(thumbTitle);
		$(".cat-extra #artworkDesc-" + thumbArticleId).html(thumbDescription);
	});
});

function popup(mylink, windowname) {
	LeftPosition = (screen.width) ? (screen.width - 500) / 2 : 0;
	TopPosition = (screen.height) ? (screen.height - 420) / 2 : 0;
	if (!window.focus) return true;
	var href;
	if (typeof(mylink) == 'string') href = mylink;
	else href = mylink.href;
	window.open(href, windowname, 'width=660,height=580,left=' + LeftPosition + ',top=' + TopPosition + '');
	return false;
}



// WEBPACK FOOTER //
// ./src/index.js